import { FormControl } from '@angular/forms';
import { FormEntity } from '@blockframes/utils/form';
import { OrgSettings } from '@blockframes/model';

function createOrganizationSettingsControls(settings: OrgSettings = {}) {
  return {
    waterfallIAEnabled: new FormControl<boolean>(settings.waterfallIAEnabled || false)
  };
}

export type OrganizationSettingsControl = ReturnType<typeof createOrganizationSettingsControls>;

export class OrganizationSettingsForm extends FormEntity<OrganizationSettingsControl> {
  constructor(settings?: OrgSettings) {
    super(createOrganizationSettingsControls(settings));
  }
} 